import gsap from "gsap";
import { resizeGameHandler } from "./resizeGameHandler";
import { Ticker } from "pixi.js";

export const configuratedStage = (stageRef) => {
    window.__PIXI_APP__ = stageRef.current.app;
    gsap.ticker.remove(gsap.updateRoot);
    Ticker.shared.add(() => {
        gsap.updateRoot(performance.now() / 1000);
    });
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
}